import React from 'react'

import { FaExternalLink } from 'react-icons/lib/fa'

const link = 'https://periscope.tv'

const Periscope = props => {
    return <div className="help__periscope">
        <h4>Setup Directions</h4>
        <ul>
            <li>Go to <strong><a target="_blank" href={link}>{link} <FaExternalLink/></a></strong></li>
            <li>After you've signed in, click on your <i>User Icon</i></li>
            <li>Select <strong>Producer</strong> from the <i>Dropdown</i></li>
            <li>Click <strong>Create New Source</strong></li>
            <li>Select <strong>Normal Source</strong> from the <i>Dropdown</i></li>
            <li>After the New Source is created, you will see a <strong>Server URL</strong> and <strong>Stream Key</strong>. Copy and Paste them into the fields above</li>
            <li>Click <strong>Add Target to Event</strong> below</li>
        </ul>
    </div>
}

export default Periscope